import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2, Clock, Check } from 'lucide-react';
import { confirmPaypalReturn } from '../lib/api';
import { useCart } from '../context/CartContext';
import logger from '../lib/logger';

const PaypalReturnPage = () => {
  const [params] = useSearchParams();
  const orderId = params.get('orderId');
  const [state, setState] = useState({ status: 'loading', order: null });
  const navigate = useNavigate();
  const { clearCart } = useCart();
  const ran = useRef(false);

  useEffect(() => {
    if (!orderId || ran.current) return;
    ran.current = true;
    confirmPaypalReturn(orderId)
      .then((order) => {
        clearCart();
        localStorage.removeItem('hh_pending_order');
        setState({ status: 'ok', order });
      })
      .catch((err) => {
        logger.error(err);
        setState({ status: 'error', order: null });
      });
  }, [orderId, clearCart]);

  return (
    <div className="bg-black text-white min-h-[70vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {state.status === 'loading' && (
          <>
            <Loader2 className="mx-auto text-[#909090] animate-spin mb-5" size={48}/>
            <h2 className="text-2xl font-bold mb-2">Confirming your return…</h2>
          </>
        )}
        {state.status === 'ok' && (
          <>
            <div className="w-16 h-16 mx-auto bg-[#909090] rounded-full flex items-center justify-center mb-5">
              <Check className="text-black" size={32}/>
            </div>
            <h2 className="text-3xl font-bold mb-3">Thank you!</h2>
            <p className="text-zinc-400 mb-2">Your order ID is <span className="text-[#909090] font-bold">{state.order?.orderId}</span></p>
            <div className="inline-flex items-center gap-2 text-amber-400 text-sm mb-4 mt-2">
              <Clock size={16}/> Awaiting PayPal payment confirmation
            </div>
            <p className="text-zinc-500 text-sm mb-6">We've sent you an email. Once we verify the PayPal payment, you'll receive a final confirmation and your order will be processed.</p>
            <div className="flex gap-3 justify-center">
              <button onClick={() => navigate(`/track?orderId=${state.order?.orderId}`)} className="bg-[#909090] hover:bg-[#a8a8a8] text-black font-semibold px-6 py-3 rounded transition-colors">
                Track order
              </button>
              <Link to="/shop" className="border border-zinc-700 hover:border-[#909090] text-white font-medium px-6 py-3 rounded transition-colors">
                Continue shopping
              </Link>
            </div>
          </>
        )}
        {state.status === 'error' && (
          <>
            <h2 className="text-2xl font-bold mb-2">Order not found</h2>
            <p className="text-zinc-400 mb-6">We couldn't locate your order. If you completed payment, please contact us with your PayPal transaction ID.</p>
            <Link to="/contact" className="inline-block bg-[#909090] hover:bg-[#a8a8a8] text-black font-semibold px-6 py-3 rounded transition-colors">Contact support</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PaypalReturnPage;
